type GenerationProgressProps = {
  generating: boolean;
};

export function GenerationProgress({ generating }: GenerationProgressProps) {
  return (
    <div className="cp-generating-indicator" role="status" aria-live="polite">
      <div className="cp-generating-indicator__dots">
        <span />
        <span />
        <span />
      </div>
      <span className="cp-generating-indicator__text">
        {generating ? 'AI is creating your outlines…' : 'AI is writing your content…'}
      </span>
    </div>
  );
}
